// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"aVi2q":[function(require,module,exports) {
var _preview = require("./dist/preview");

},{"./dist/preview":"bdZqR"}],"bdZqR":[function(require,module,exports) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _global = require("@storybook/global");
var _previewApi = require("@storybook/preview-api");
var ADDON_ID = "storybook/a11y";
var RESULT = "".concat(ADDON_ID, "/result"), REQUEST = "".concat(ADDON_ID, "/request"), RUNNING = "".concat(ADDON_ID, "/running"), ERROR = "".concat(ADDON_ID, "/error"), MANUAL = "".concat(ADDON_ID, "/manual"), EVENTS = {
    RESULT: RESULT,
    REQUEST: REQUEST,
    RUNNING: RUNNING,
    ERROR: ERROR,
    MANUAL: MANUAL
};
var document = (0, _global.global).document, globalWindow = (0, _global.global).window, channel = (0, _previewApi.addons).getChannel(), active = !1, activeStoryId, handleRequest = function() {
    var _ref = (0, _asyncToGenerator._)(function(storyId) {
        var manual, _tmp;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getParams(storyId)
                    ];
                case 1:
                    manual = _state.sent().manual;
                    _tmp = manual;
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        run(storyId)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    });
    return function handleRequest(storyId) {
        return _ref.apply(this, arguments);
    };
}(), run = function() {
    var _ref = (0, _asyncToGenerator._)(function(storyId) {
        var input, axe, _input_element, element, config, _input_options, options, htmlElement, result, resultJson, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    activeStoryId = storyId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    return [
                        4,
                        getParams(storyId)
                    ];
                case 2:
                    input = _state.sent();
                    if (!!active) return [
                        3,
                        5
                    ];
                    active = !0, channel.emit(EVENTS.RUNNING);
                    return [
                        4,
                        require("89abf3a7c3a87096")
                    ];
                case 3:
                    axe = _state.sent().default, _input_element = input.element, element = _input_element === void 0 ? "#storybook-root" : _input_element, config = input.config, _input_options = input.options, options = _input_options === void 0 ? {} : _input_options, htmlElement = document.querySelector(element);
                    if (!htmlElement) return [
                        2
                    ];
                    axe.reset(), config && axe.configure(config);
                    return [
                        4,
                        axe.run(htmlElement, options)
                    ];
                case 4:
                    result = _state.sent(), resultJson = JSON.parse(JSON.stringify(result));
                    activeStoryId === storyId ? channel.emit(EVENTS.RESULT, resultJson) : (active = !1, run(activeStoryId));
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    error = _state.sent();
                    channel.emit(EVENTS.ERROR, error);
                    return [
                        3,
                        8
                    ];
                case 7:
                    active = !1;
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function run(storyId) {
        return _ref.apply(this, arguments);
    };
}(), getParams = function() {
    var _ref = (0, _asyncToGenerator._)(function(storyId) {
        var parameters;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        globalWindow.__STORYBOOK_STORY_STORE__.loadStory({
                            storyId: storyId
                        })
                    ];
                case 1:
                    parameters = (_state.sent() || {}).parameters;
                    return [
                        2,
                        parameters.a11y || {
                            config: {},
                            options: {}
                        }
                    ];
            }
        });
    });
    return function getParams(storyId) {
        return _ref.apply(this, arguments);
    };
}();
channel.on(EVENTS.REQUEST, handleRequest);
channel.on(EVENTS.MANUAL, run);

},{"@swc/helpers/_/_async_to_generator":"eTGQ5","@swc/helpers/_/_ts_generator":"hIXl2","@storybook/global":"i6gHT","@storybook/preview-api":"3zhcF","89abf3a7c3a87096":"lkReF"}],"lkReF":[function(require,module,exports) {
module.exports = require("3f0cbf5595232583")(require("446f8f719299052e").resolve("6dcXm")).then(function() {
    return module.bundle.root('lKlEc');
});

},{"3f0cbf5595232583":"eMB0p","446f8f719299052e":"hY41h"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.6f9a7cc2.js.map
